import { ApiService } from './api.services';
import { BaseService } from 'app/core/base.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebStatusSeguradora } from '../models/webStatusSeguradora.model';

export class WebStatusSeguradoraService extends ApiService implements BaseService<WebStatusSeguradora>{

    private strAction = 'api/WebStatusSeguradora';

    constructor(
        httpClient: HttpClient,
        private route: Router) {
        super(httpClient, route);
    }

    getAll(): Observable<WebStatusSeguradora[]> {
        return this.get<WebStatusSeguradora[]>(this.strAction + `/GetAll`);
    }

    deleteById(id: number) {
        return this.post(this.strAction + `/DeleteById?id=${id}`);
    }


    getById(id: number): Observable<WebStatusSeguradora> {
        return this.get<WebStatusSeguradora>(this.strAction + `/GetById/${id}`);
    }


    Put(webStatusSeguradora: WebStatusSeguradora): Observable<WebStatusSeguradora> {
        return this.post<WebStatusSeguradora>(this.strAction + `/Put`, webStatusSeguradora);
    }

    Post(webStatusSeguradora: WebStatusSeguradora): Observable<WebStatusSeguradora> {
        return this.post<WebStatusSeguradora>(this.strAction + `/Post`, webStatusSeguradora);
    }


}